{
  "razaoSocial": "",
  "nomeFantasia": "MasterHub",
  "cnpj": "",
  "telefone": "",
  "whatsapp": "",
  "email": "",
  "logo": "",
  "endereco": {
    "logradouro": "",
    "numero": "",
    "complemento": "",
    "bairro": "",
    "cidade": "",
    "uf": "",
    "cep": ""
  }
}
